import { useTranslation } from 'react-i18next'
import ComparisonSummary from './ComparisonSummary'
import { Product } from '../../stores/appReportsStore'
import { calculateTotalSpent } from '../../services/import/importProductIdsService'
import SummaryLeftProductCard from './summary/SummaryLeftProductCard'
import SummaryRightProductCard from './summary/SummaryRightProductCard'


export interface SourcingSummaryComponentProps {
  productsMap: Record<string, Product>
  selectedMap: Record<string, Product>
}

export default function SourcingSummaryComponent({
  productsMap,
  selectedMap,
}: SourcingSummaryComponentProps) {
  const { t } = useTranslation()

  const diffs = Object.entries(selectedMap)
    .map(([parentId, selected]) => {
      const parent = productsMap[parentId]!
      const diff = calculateTotalSpent(parent) - calculateTotalSpent(selected)
      return { parent, selected, diff }
    })
    .filter(d => d.selected.articleId !== d.parent.articleId)
    .sort((a, b) => b.diff - a.diff)

  return (
    <>
      <div className="max-w-7xl mx-auto mb-6">
        <ComparisonSummary productsMap={productsMap} selectedMap={selectedMap} />
      </div>

      {diffs.length === 0 ? (
        <p className="text-center text-muted dark:text-muted-dark">
          {t('sourcing.noChanges')}
        </p>
      ) : (
        <div className="max-w-7xl mx-auto my-4">
          {diffs.map(({ parent, selected }) => (
            <div
              key={parent.articleId}
              className="flex flex-col items-center gap-2 min-[1265px]:flex-row min-[1265px]:mb-4"
            >
              {/* left card */}
              <div className="w-full max-w-[600px] mx-auto min-[1265px]:flex-1 min-w-0">
                <SummaryLeftProductCard product={parent} />
              </div>

              {/* separator */}
              <img
                src="/icons/separator_side.png"
                alt=""
                className="w-4 h-1.5 flex-none hidden min-[1265px]:flex"
              />
              <img
                src="/icons/separator_top.png"
                alt=""
                className="w-1.5 h-4 flex-none flex min-[1265px]:hidden"
              />

              {/* right card */}
              <div className="w-full max-w-[600px] mx-auto min-[1265px]:flex-1 min-w-0">
                <SummaryRightProductCard parentProduct={parent} product={selected} />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}
